import header from './index.vue'
header.install = Vue => Vue.component(header.name, header)
export default header
